import { useEffect, useState } from 'react';

export default function BackTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!show) return null;

  return (
    <a
      href="#breaking"
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-soft transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true" />
    </a>
  );
}